/**************************************************
 * Nombre:       Formulario_Producto_Especificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import Formulario_Producto_Especificaciones_Ingreso from "./Formulario_Producto_Especificaciones_Ingreso";
import Tarjetas_Producto_Especificacion from "../../Tarjeta/Tarjetas_Producto_Especificacion";

const Formulario_Producto_Especificaciones = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Guardar Especificacion',
        dato: 'lista_espe',
        Tarjeta: Tarjetas_Producto_Especificacion,
        Formulario: Formulario_Producto_Especificaciones_Ingreso
    })

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Especificaciones'} dato={'especificaciones'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Especificaciones